export enum PendingEntryStatus {
  PENDING = 'pending',
  UNDER_REVIEW = 'under_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum EntityType {
  STAKEHOLDER = 'stakeholder',
  ORGANIZATION = 'organization',
  ASSIGNMENT = 'assignment',
  WIKI_PAGE = 'wiki_page',
}

export interface User {
  id: string;
  email: string;
  role: string;
}

export interface PendingEntry {
  id: string;
  entityType: EntityType;
  entityData: any;
  submittedBy: string;
  submitter: User;
  assignedTo?: string;
  assignee?: User;
  status: PendingEntryStatus;
  reviewNotes?: string;
  submittedAt: string;
  reviewedAt?: string;
}

export interface ChangeProposal {
  id: string;
  entityType: EntityType;
  entityId: string;
  originalData: any;
  proposedChanges: any;
  proposedBy: string;
  proposer: User;
  assignedTo?: string;
  assignee?: User;
  status: PendingEntryStatus;
  reviewNotes?: string;
  proposedAt: string;
  reviewedAt?: string;
}

export interface WorkflowQuery {
  status?: PendingEntryStatus;
  entityType?: EntityType;
  assignedTo?: string;
  submittedBy?: string;
  page?: number;
  limit?: number;
}

export interface ReviewRequest {
  status: PendingEntryStatus.APPROVED | PendingEntryStatus.REJECTED;
  reviewNotes?: string;
}

export interface WorkflowResponse<T> {
  data: T[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface MyAssignmentsResponse {
  pendingEntries: WorkflowResponse<PendingEntry>;
  changeProposals: WorkflowResponse<ChangeProposal>;
}

export interface MySubmissionsResponse {
  pendingEntries: WorkflowResponse<PendingEntry>;
  changeProposals: WorkflowResponse<ChangeProposal>;
}